import React, { useId } from 'react';
import { Controller } from 'react-hook-form';
import { clsx } from 'clsx';
import { Switch } from 'src/components/ui/switch';
import { InputInfoToolTip } from 'src/components/Input/InputInfoToolTip';

export const AIAssistantModeFiled = ({
  control,
  name = 'reply_to_note',
  className = '',
  disabled = false,
}: {
  control: any;
  name?: string;
  className?: string;
  disabled?: boolean;
}) => {
  const id = useId();

  return (
    <div className={clsx('content', className)}>
      <div>
        <div className="flex gap-2.5">
          <Controller
            control={control}
            name={name}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <Switch id={id} checked={value} onCheckedChange={onChange} disabled={disabled} />
            )}
          />
          <div className="flex flex-col gap-2.5">
            <label
              htmlFor={id}
              className="flex flex-row gap-1.5 items-center opacity-80 font-semibold text-sm text-ebony font-jamjuree"
            >
              <span>AI assistant mode</span>
              <InputInfoToolTip
                contentClassName={'max-w-[200px] opacity-100 bg-white'}
                infoToolTip={{
                  side: 'right',
                  description: (
                    <>
                      When enabled, AI replies will not be sent to customers, but will be posted as
                      internal notes in tickets.
                    </>
                  ),
                }}
              />
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};
